module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/141assets/fonts/90650e7d8178a15c2b227dba52850c85.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 757
// module chunks = 4